export default [
  {
    name: 'Linode',
    url: 'http://linode.com/developertea',
    logoUrl: '/static/img/sponsors/linode.png',
  },

  {
    name: 'App Center',
    url:
      'https://appcenter.ms/?utm_source=Fragmented_podcast&utm_medium=newsletter&utm_campaign=appcenter_Fragmengted',
    logoUrl: '/static/img/sponsors/app-center.jpg',
  },
  {
    name: 'New Relic',
    url: 'https://newrelic.com',
    logoUrl: '/static/img/sponsors/newrelic_logo.png',
  },

  {
    name: 'Twist',
    url: 'https://twistapp.com/',
    logoUrl: '/static/img/sponsors/twistapp.png',
  },

  {
    name: 'Digital Ocean',
    url:
      'https://try.digitalocean.com/performance/?utm_medium=podcast&utm_campaign=DoesNotCompute%7CPodcast%7CPricePerf_100&utm_source=does_not_compute',
    logoUrl: '/static/img/sponsors/digital-ocean.png',
  },

  {
    name: 'Dropbox',
    url: 'https://dropbox.com',
    logoUrl: '/static/img/sponsors/dropbox.png',
  },

  {
    name: 'Square',
    url: 'https://developer.squareup.com/',
    logoUrl: '/static/img/sponsors/square.png',
  },

  {
    name: 'UENO',
    url: 'https://ueno.co',
    logoUrl: '/static/img/sponsors/ueno.png',
  },

  {
    name: 'Zendesk',
    url:
      'https://www.zendesk.com/in-app-customer-service/?utm_medium=display&utm_source=specfm&utm_campaign=Little%2BBites%2BCocoa',
    logoUrl: '/static/img/sponsors/zendesk.png',
  },

  {
    name: 'Abstract',
    url:
      'https://www.goabstract.com/?&utm_medium=Partner-Advertising&utm_source=PA-Podcast&utm_campaign=CY-19-PA-Podcast-DesignDetails&utm_content=Logo',
    logoUrl: '/static/img/sponsors/abstract.png',
  },

  {
    name: 'Shopify',
    url: 'https://www.shopify.com/careers',
    logoUrl: '/static/img/sponsors/shopify.png',
  },

  {
    name: 'Dolby',
    url: 'https://goo.gl/CMMT6j',
    logoUrl: '/static/img/sponsors/dolby.png',
  },

  {
    name: 'Asana',
    url: 'https://asana.design/',
    logoUrl: '/static/img/sponsors/asana.png',
  },

  {
    name: 'Gusto',
    url:
      'https://gusto.com/about/careers?utm_source=spec.fm&utm_campaign=careers',
    logoUrl: '/static/img/sponsors/gusto.png',
  },

  {
    name: 'InstaBug',
    url: 'https://instabug.com/swift',
    logoUrl: '/static/img/sponsors/instabug.png',
  },

  {
    name: 'Stack Overflow',
    url: 'https://stackoverflow.com/',
    logoUrl: '/static/img/sponsors/stack-overflow.png',
  },

  {
    name: 'Swipies',
    url: 'http://www.swipi.es/',
    logoUrl: '/static/img/sponsors/swipies.png',
  },

  {
    name: 'Bitrise',
    url:
      'https://www.bitrise.io/?utm_source=fragmented_podcast&utm_medium=cpc&utm_campaign=fragmented_podcast&utm_content=spec_logo',
    logoUrl: '/static/img/sponsors/bitrise.png',
  },

  {
    name: 'Hired',
    url:
      'https://hired.com/?utm_source=podcast&amp;utm_medium=specfm&amp;utm_campaign=sponsorpage',
    logoUrl: '/static/img/sponsors/hired.png',
  },

  {
    name: 'UX Design Masterclass',
    url: 'https://uxdesignmasterclass.com',
    logoUrl: '/static/img/sponsors/uxdmc.png',
  },

  {
    name: 'Conference Calling',
    url: 'https://www.conferencecalling.com/',
    logoUrl: '/static/img/sponsors/vast-conference.png',
  },

  {
    name: 'Data Dog',
    url:
      'https://www.datadoghq.com/?utm_source=Advertisement&utm_medium=Advertisement&utm_campaign=Spec-Sponsorship',
    logoUrl: '/static/img/sponsors/datadog.png',
  },

  {
    name: 'Reaktor',
    url: 'https://reaktor.com/careers',
    logoUrl: '/static/img/sponsors/reaktor.png',
  },

  {
    name: 'Dot Design',
    url: 'https://porkbun.com/?coupon=SPEC',
    logoUrl: '/static/img/sponsors/dotdesign.png',
  },

  {
    name: 'Story Blocks',
    url: 'https://storyblocks.com/doesnotcompute',
    logoUrl: '/static/img/sponsors/storyblocks.png',
  },

  {
    name: 'Webflow',
    url: 'https://webflow.com/ix2?utm_source=designdetails',
    logoUrl: '/static/img/sponsors/webflow.png',
  },

  {
    name: 'Swiftype',
    url: 'https://swiftype.com/DoesNotCompute',
    logoUrl: '/static/img/sponsors/swiftype.png',
  },

  {
    name: 'Flywheel',
    url: 'https://bit.ly/2JZWSSD',
    logoUrl: '/static/img/sponsors/flywheel.png',
  },

  {
    name: 'Ready Desk',
    url: 'http://www.thereadydesk.com/',
    logoUrl: '/static/img/sponsors/readydesk.png',
  },

  {
    name: 'Jump Chart',
    url: 'https://www.jumpchart.com/?ref=orthogonal',
    logoUrl: '/static/img/sponsors/jumpchart.png',
  },

  {
    name: 'Figma',
    url: 'https://www.figma.com/careers',
    logoUrl: '/static/img/sponsors/figma.png',
  },

  {
    name: 'Kobiton',
    url:
      'https://kobiton.com/?utm_source=Spec%20Podcast%20Page&utm_medium=Spec%20Sponsorship%20Page&utm_campaign=Spec%20Sponsorship%20Page&utm_term=Device%20Lab%20Management&utm_content=Production',
    logoUrl: '/static/img/sponsors/kobiton.png',
  },

  {
    name: 'Fuse',
    url: 'https://fusetools.com',
    logoUrl: '/static/img/sponsors/fuse.png',
  },

  {
    name: 'Perfect',
    url: 'http://perfect.org/en/assistant/',
    logoUrl: '/static/img/sponsors/perfect.png',
  },

  {
    name: 'Flow',
    url: 'https://getflow.com/designdetails',
    logoUrl: '/static/img/sponsors/flow.png',
  },

  {
    name: 'Pusher',
    url: 'https://pusher.com/?utm_source=spec.fm%2Fpusher&utm_medium=referral',
    logoUrl: '/static/img/sponsors/pusher.png',
  },

  {
    name: 'UX Pin',
    url:
      'https://www.uxpin.com/layout?utm_source=spec-podc&utm_medium=podcast&utm_campaign=layout-sponsorship',
    logoUrl: '/static/img/sponsors/uxpin.png',
  },

  {
    name: 'PSPDF Kit',
    url: 'https://pspdfkit.com/',
    logoUrl: '/static/img/sponsors/pspd.png',
  },

  {
    name: 'Flatiron School',
    url:
      'https://flatironschool.com/programs/online-bootcamp-prep-course/?coupon=lv-developer-tea&utm_campaign=Sponsored_Content&utm_medium=Podcast&utm_source=Developer%20Tea',
    logoUrl: '/static/img/sponsors/flatiron.png',
  },

  {
    name: 'Pluot',
    url: 'http://pluot.co/orthogonal',
    logoUrl: '/static/img/sponsors/pluot.png',
  },

  {
    name: 'Chart.io',
    url:
      'https://chartio.com?utm_source=specfm&utm_medium=podcast&utm_campaign=devtea_specfm',
    logoUrl: '/static/img/sponsors/chartio.png',
  },

  {
    name: 'Whiteboard',
    url: 'http://whiteboard.is/',
    logoUrl: '/static/img/sponsors/whiteboard.png',
  },

  {
    name: 'Managed By Q',
    url: 'http://grnh.se/xrvmq2',
    logoUrl: '/static/img/sponsors/q.png',
  },

  {
    name: 'RefactorU',
    url: 'http://www.refactoru.com/courses/web-development',
    logoUrl: '/static/img/sponsors/refactor.png',
  },

  {
    name: 'Skurt',
    url: 'http://skurt.com/jobs',
    logoUrl: '/static/img/sponsors/skurt.png',
  },

  {
    name: 'OneMonth',
    url: 'https://onemonth.com/developertea',
    logoUrl: '/static/img/sponsors/onemonth.png',
  },

  {
    name: 'WooCommerce',
    url:
      'http://www.woocommerce.com/developertea?utm_source=podcast&utm_medium=website&utm_campaign=developertea',
    logoUrl: '/static/img/sponsors/woo.png',
  },

  {
    name: 'Intuit',
    url: 'http://intuit.me/DevTea',
    logoUrl: '/static/img/sponsors/intuit.png',
  },

  {
    name: 'Mapbox',
    url: 'http://www.mapbox.com/android',
    logoUrl: '/static/img/sponsors/mapbox.png',
  },

  {
    name: 'Headspace',
    url: 'http://headspace.com',
    logoUrl: '/static/img/sponsors/headspace.png',
  },

  {
    name: 'Nerdery',
    url: 'http://www.nerdery.com/careers',
    logoUrl: '/static/img/sponsors/nerdery.png',
  },

  {
    name: 'Freshbooks',
    url: 'https://www.freshbooks.com/specfm',
    logoUrl: '/static/img/sponsors/freshbooks.png',
  },

  {
    name: 'Etsy',
    url: 'https://etsy.com/careers',
    logoUrl: '/static/img/sponsors/etsy.png',
  },

  {
    name: 'Rollbar',
    url: 'https://rollbar.com/',
    logoUrl: '/static/img/sponsors/rollbar.png',
  },

  {
    name: 'Dringend',
    url: 'http://dringend.cc/',
    logoUrl: '/static/img/sponsors/dringend.png',
  },

  {
    name: 'Codeship',
    url: 'https://codeship.com/?ref=specfm',
    logoUrl: '/static/img/sponsors/codeship.png',
  },

  {
    name: 'Heap',
    url:
      'http://heapanalytics.com/enterprise?utm_source=podcast&utm_medium=redirect&utm_campaign=spec1',
    logoUrl: '/static/img/sponsors/heap.png',
  },

  {
    name: 'Harvest',
    url: 'https://www.getharvest.com/',
    logoUrl: '/static/img/sponsors/harvest.png',
  },

  {
    name: 'Launch Kit',
    url: 'https://launchkit.io',
    logoUrl: '/static/img/sponsors/launchkit.png',
  },

  {
    name: 'Wake',
    url: 'https://wake.io',
    logoUrl: '/static/img/sponsors/wake.png',
  },

  {
    name: 'Imgix',
    url: 'https://imgix.com',
    logoUrl: '/static/img/sponsors/imgix.png',
  },

  {
    name: 'Code School',
    url: 'https://codeschool.com',
    logoUrl: '/static/img/sponsors/codeschool.png',
  },

  {
    name: 'Adobe',
    url: 'https://adobe.com',
    logoUrl: '/static/img/sponsors/adobe.png',
  },

  {
    name: 'InVision_Studio',
    url: 'https://www.invisionapp.com/studio',
    logoUrl: '/static/img/sponsors/invision_studio.png',
  },

  {
    name: 'Buddybuild',
    url: 'http://www.buddybuild.com/',
    logoUrl: '/static/img/sponsors/buddybuild.png',
  },

  {
    name: 'Hover',
    url: 'https://hover.com/?ref=specfm',
    logoUrl: '/static/img/sponsors/hover.png',
  },

  {
    name: 'Weebly',
    url: 'https://weebly.com/?ref=specfm',
    logoUrl: '/static/img/sponsors/weebly.png',
  },

  {
    name: 'Rollout',
    url:
      'https://rollout.io/?utm_source=specfm&utm_medium=web&utm_content=sponsorpage',
    logoUrl: '/static/img/sponsors/rollout.png',
  },

  {
    name: 'Pixate',
    url: 'http://pixate.com/?ref=specfm',
    logoUrl: '/static/img/sponsors/pixate.png',
  },

  {
    name: 'Bugsee',
    url:
      'https://www.bugsee.com/?utm_campaign=LittleBitesOfCocoa&amp;utm_medium=web&amp;utm_source=jake',
    logoUrl: '/static/img/sponsors/bugsee.png',
  },

  {
    name: 'Icon Finder',
    url: 'https://iconfinder.com/?ref=specfm',
    logoUrl: '/static/img/sponsors/iconfinder.png',
  },

  {
    name: 'ProtoPie',
    url: 'https://bit.ly/2otlJ6d',
    logoUrl: '/static/img/sponsors/protopie.png',
  },

  {
    name: '.Tech',
    url:
      'https://get.tech/future-on-tech?utm_source=SPEC&utm_medium=Podcast&utm_campaign=F_uture_SPF&utm_term=stups',
    logoUrl: '/static/img/sponsors/tech_domains.jpg',
  },

  {
    name: 'American Express',
    url: 'https://americanexpress.io/android-jobs',
    logoUrl: '/static/img/sponsors/amex_logo.jpg',
  },

  {
    name: 'Manifold',
    url: 'https://www.manifold.co/devtea',
    logoUrl: '/static/img/sponsors/manifold.png',
  },

  {
    name: 'Nevercode',
    url: 'https://nevercode.io',
    logoUrl: '/static/img/sponsors/nevercode.png',
  },

  {
    name: 'duckduckgo',
    url: 'https://duckduckgo.com/',
    logoUrl: '/static/img/sponsors/duckduckgo.png',
  },

  {
    name: 'Discover.bot',
    url: 'https://bit.ly/2K3YOIN',
    logoUrl: '/static/img/sponsors/discoverbot.png',
  },

  {
    name: 'Sentry.io',
    url: 'https://www.sentry.io',
    logoUrl: '/static/img/sponsors/sentry.png',
  },

  {
    name: 'Readymag',
    url:
      'https://readymag.com/?utm_source=newsletter&utm_campaign=designdetails',
    logoUrl: '/static/img/sponsors/readymag.png',
  },

  {
    name: 'ImageKit.io',
    url: 'https://imagekit.io?utm_source=developertea&utm_medium=podcast',
    logoUrl: '/static/img/sponsors/imagekit.png',
  },

  {
    name: 'Clubhouse',
    url: 'https://clubhouse.io/',
    logoUrl: '/static/img/sponsors/Clubhouse.png',
  },

  {
    name: 'Vettery',
    url:
      'https://www.vettery.com/tech?utm_source=podcast&utm_medium=specfm&utm_term=tech&utm_content=grouped&utm_campaign=ad-92198',
    logoUrl: '/static/img/sponsors/vettery.png',
  },

  {
    name: 'GitPrime',
    url: 'https://www.pluralsight.com/product/flow/20-patterns',
    logoUrl: '/static/img/sponsors/gitprime.png',
  },

  {
    name: 'Infinite Red',
    url: 'remote.infinite.red',
    logoUrl: '/static/img/sponsors/infiniteredlogo.png',
  },

  {
    name: 'G2i',
    url:
      'https://www.g2i.co/?utm_source=React_radio_podcast&utm_medium=Podcast%20Link',
    logoUrl: '/static/img/sponsors/g2i.png',
  },

  {
    name: 'Stackbit',
    url: 'https://www.stackbit.com/developertea',
    logoUrl: '/static/img/sponsors/Stackbit-logo.png',
  },
  {
    name: 'Bluemedora',
    url: 'https://bluemedora.com/compute-layer-vrealize-operations/',
    logoUrl: '/static/img/sponsors/bluemedora.png',
  },

  {
    name: 'Barclays',
    url:
      'https://ad.doubleclick.net/ddm/clk/449554279;253430086;p?https://home.barclays/careers/campaigns/developers/?utm_source=redapplecreative.co.uk&utm_medium=logo/sponsorship&utm_campaign=bx-developers&utm_term=us-nationwide&utm_content=NA',
    logoUrl: '/static/img/sponsors/Barclays.png',
  },

  {
    name: 'Sky Silk',
    url:
      'https://www.skysilk.com/?utm_source=Podcast&utm_medium=Newsletter&utm_campaign=Developer_Tea_Time',
    logoUrl: '/static/img/sponsors/skysilk.png',
  },
  {
    name: 'Toptal',
    url: 'http://go.thoughtleaders.io/1280920190926',
    logoUrl: '/static/img/sponsors/toptalogo.png',
  },
  {
    name: 'GiveWell',
    url: 'https://www.givewell.org/developertea',
    logoUrl: '/static/img/sponsors/givewell.png',
  },
  {
    name: 'Pathrise',
    url:
      'https://www.pathrise.com/?utm_source=sponsored_media&utm_campaign=developer_tea&utm_medium=podcast',
    logoUrl: '/static/img/sponsors/pathriselogo.png',
  },
  {
    name: 'Oxylabs',
    url:
      'https://oxylabs.io/developertea?utm_source=newsletter&utm_medium=email&utm_campaign=developer_tea',
    logoUrl: '/static/img/sponsors/oxylabslogo.png',
  },
  {
    name: 'XTeam',
    url: 'https://x-team.com/developertea',
    logoUrl: '/static/img/sponsors/xteam.png',
  },
  {
    name: 'ProdPerfect',
    url:
      'https://landing.prodperfect.com/tea.html?utm_source=tea&utm_medium=advertisement&utm_campaign=core_demo_request',
    logoUrl: '/static/img/sponsors/ProdPerfect.png',
  },
  {
    name: 'Educative.io',
    url: 'http://www.educative.io/',
    logoUrl: '/static/img/sponsors/educative.png',
  },
  {
    name: 'HeadSpin.io',
    url:
      'https://www.headspin.io/?utm_source=devtea&utm_medium=podcast&utm_campaign=brand_awareness',
    logoUrl: '/static/img/sponsors/headspin.png',
  },
  {
    name: 'Float',
    url: 'https://www.float.com/?utm_source=designdetails&utm_medium=specfm',
    logoUrl: '/static/img/sponsors/float.png',
  },
  {
    name: 'ZeBrand',
    url:
      'https://zebranding.com/?utm_source=podcast&utm_medium=spec&utm_campaign=devtea',
    logoUrl: '/static/img/sponsors/zebrand.png',
  },
  {
    name: 'Command Line Heroes',
    url: 'https://www.redhat.com/en/command-line-heroes',
    logoUrl: '/static/img/sponsors/clhlogo.png',
  },
  {
    name: 'Honeybadger',
    url:
      'https://www.honeybadger.io/?utm_source=reactpodcast_toolsday&utm_medium=email&utm_campaign=podcast',
    logoUrl: '/static/img/sponsors/honeybadgerlogo.png',
  },
  {
    name: 'Retool',
    url: 'https://retool.com/?utm_source=spec&utm_medium=podcast',
    logoUrl: '/static/img/sponsors/retoollogo.png',
  },
  {
    name: 'TestCafe',
    url: 'https://devexpress.github.io/testcafe/',
    logoUrl: '/static/img/sponsors/testcafelogo.png',
  },
  {
    name: 'DeepSource',
    url: 'https://deepsource.io/?ref=devtea',
    logoUrl: '/static/img/sponsors/deepsource 1.png',
  },
  {
    name: 'CuriosityStream',
    url: 'https://curiositystream.com/design',
    logoUrl: '/static/img/sponsors/curiositystreamlogo.png',
  },

  {
    name: 'AWS Amplify',
    url:
      'https://aws.amazon.com/getting-started/hands-on/build-react-app-amplify-graphql/',
    logoUrl: '/static/img/sponsors/amplify.png',
  },
  {
    name: 'Monday.com',
    url:
      'https://mondayapps.devpost.com/?utm_source=monday&utm_medium=podcast&utm_campaign=devtea',
    logoUrl: '/static/img/sponsors/mondaylogo.png',
  },
   {
    name: 'Outsystems',
    url:
      'https://www.outsystems.com/free-edition/?utm_source=specfm&utm_medium=referral&utm_campaign=2020-toolsday-sponsorship&utm_term=camp-gl&utm_content=personal-environment',
    logoUrl: '/static/img/sponsors/outsystemslogo.png',
  },
]
